import { defineLocale } from "../../registry";

const publishing = defineLocale({
  ru: {
    "publishing.title": "Чек-лист публикации",
    "publishing.refresh": "Обновить",
    "publishing.publish": "Опубликовать",
    "publishing.publishing": "Публикация…",
    "publishing.empty": "Сервер не вернул пунктов чек-листа",
    "publishing.mark.ok": "Выполнено",
    "publishing.mark.fail": "Не выполнено",
    "publishing.item.deal_status": "Статус сделки",
    "publishing.item.compliance": "Соответствие требованиям",
    "publishing.item.rights": "Права на материалы",
    "publishing.item.copy_en": "Английский текст",
    "publishing.item.price_fresh": "Актуальность цены",
    "publishing.item.window": "Окно доступности",
    "publishing.item.cover": "Обложка",
    "publishing.item.geo_rights": "Права на геометрию",
    "publishing.item.link_alive": "Рабочая ссылка",
    "publishing.item.unknown": "Неизвестный пункт: {key}",
    "publishing.reason.ok": "Требование выполнено",
    "publishing.reason.failed": "Требование не выполнено",
    "publishing.reason.restricted":
      "Требование не выполнено. Подробности доступны ролям с доступом к B2B-данным.",
    "publishing.reason.rights":
      "Права на обложку или материалы не подтверждены",
    "publishing.reason.copy_en": "Нет английского текста",
    "publishing.reason.price_fresh": "Цена устарела и требует проверки",
    "publishing.reason.window": "Окно доступности задано неверно",
    "publishing.reason.cover": "Не задана обложка",
    "publishing.reason.geo_rights":
      "Источник, лицензия или права на геометрию не подтверждены",
    "publishing.reason.unknown":
      "Требование не выполнено. Эта версия консоли не распознаёт пункт.",
    "publishing.blockers.title": "Мешает публикации",
    "publishing.blockers.unspecified":
      "Сервер пока не разрешает публикацию, но не назвал причину",
    "publishing.published": "Опубликовано",
    "publishing.error.gateFailed":
      "Публикация заблокирована: чек-лист изменился, проверьте пункты ниже",
  },
  en: {
    "publishing.title": "Publication checklist",
    "publishing.refresh": "Refresh",
    "publishing.publish": "Publish",
    "publishing.publishing": "Publishing…",
    "publishing.empty": "The server returned no checklist items",
    "publishing.mark.ok": "Done",
    "publishing.mark.fail": "Not done",
    "publishing.item.deal_status": "Deal status",
    "publishing.item.compliance": "Compliance",
    "publishing.item.rights": "Rights",
    "publishing.item.copy_en": "English copy",
    "publishing.item.price_fresh": "Price freshness",
    "publishing.item.window": "Availability window",
    "publishing.item.cover": "Cover",
    "publishing.item.geo_rights": "Geometry rights",
    "publishing.item.link_alive": "Link alive",
    "publishing.item.unknown": "Unrecognized check: {key}",
    "publishing.reason.ok": "Requirement met",
    "publishing.reason.failed": "Requirement not met",
    "publishing.reason.restricted":
      "Requirement not met. Details are available to roles with B2B access.",
    "publishing.reason.rights": "Rights to the cover or media are not confirmed",
    "publishing.reason.copy_en": "English copy is missing",
    "publishing.reason.price_fresh": "The price is stale and needs a check",
    "publishing.reason.window": "The availability window is invalid",
    "publishing.reason.cover": "No cover is set",
    "publishing.reason.geo_rights":
      "Geometry source, license or rights are not confirmed",
    "publishing.reason.unknown":
      "Requirement not met. This console version does not recognize the check.",
    "publishing.blockers.title": "Blocking publication",
    "publishing.blockers.unspecified":
      "The server does not allow publishing yet but gave no reason",
    "publishing.published": "Published",
    "publishing.error.gateFailed":
      "Publishing is blocked: the checklist has changed, review the items below",
  },
});

export default publishing;
